<template>
  <div class="action">
    <button @click="openIncidentDetails" class="check-in">Besondere <br> Vorkommnisse</button>
    <button v-if="flightLog.activeSupervisor" @click="signOutSupervisor" class="check-in">Als Flugleiter <br> austragen</button>
    <button v-else @click="signInSupervisor" class="check-in">Als Flugleiter <br> eintragen</button>
    <button v-if="flightLog.activePilot" @click="signOutPilot" class="check-in">Als Pilot <br> austragen</button>
    <button v-else @click="signInPilot" class="check-in">Als Pilot <br> eintragen</button>
  </div>
</template>

<script>
export default {
    name: "ActionPanel",
    props: ['flightLog'],
    setup(props, context) {
        const openIncidentDetails = () => {
          console.log('Open Incident Details')
          context.emit('openIncidentDetails');
        }
        
        function signOutSupervisor() {
          context.emit('signOutSupervisor')
        }
        
        function signInSupervisor() {
          context.emit('signInSupervisor')
        }
        
        const signOutPilot = () => {
          console.log('signOut')
          context.emit('signOutPilot');
        }
        
        const signInPilot = () => {
          console.log('signIn')
          context.emit('openSignInDetails');
        }
        
        return {signInPilot, signOutPilot, signInSupervisor, signOutSupervisor, openIncidentDetails}
    }
}
</script>

<style>
.action {
    background-color: #ddd;
    display:flex;
    justify-content: space-around;
    align-items: center;
}

.check-in {
  background-color: crimson;
  color: white;
  border: none;
  border-radius: 15px;
  outline: none;
  padding: 8px 0;
  margin: 0;
  width: 112px;
  font-size: 16px;
    -webkit-text-size-adjust: none; /* Disable text size adjustment for WebKit browsers */
  -moz-text-size-adjust: none; /* Disable text size adjustment for Mozilla browsers */
  -ms-text-size-adjust: none; /* Disable text size adjustment for Microsoft browsers */
  text-size-adjust: none; /* Disable text size adjustment for other browsers */

}
</style>